import { render, staticRenderFns } from "./BranchLocationTable.vue?vue&type=template&id=5d2e9274&scoped=true&"
import script from "./BranchLocationTable.vue?vue&type=script&lang=js&"
export * from "./BranchLocationTable.vue?vue&type=script&lang=js&"
import style0 from "./BranchLocationTable.vue?vue&type=style&index=0&id=5d2e9274&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2e9274",
  null
  
)

export default component.exports